import GameModal from './GameModal'
export default GameModal;